import React, { ReactNode } from "react";
import { Typography } from "components/atoms";
import { Spinner } from "components/atoms/Icon";
import { useAppSelector } from "hooks";
import "./index.scss";

interface Props {
  isRefreshing: boolean;
  aiChatDrawerStatus: string;
  theme?: "light" | "dark";
  message?: ReactNode;
}

export const IframeRefreshOverlay = ({
  isRefreshing,
  aiChatDrawerStatus,
  theme,
  message = (
    <>
      Updating your progress.
      <br />
      This will only take a moment.
    </>
  ),
}: Props) => {
  const { mode } = useAppSelector((state) => state.theme);
  const resolvedTheme = theme ?? mode;

  if (!isRefreshing) return null;

  const aiStateClass =
    aiChatDrawerStatus === "open"
      ? "iframe-modal-ai-open"
      : aiChatDrawerStatus === "closed"
        ? "iframe-modal-ai-collapsed"
        : "";

  return (
    <div
      className={`iframe-modal-refresh-loading-exclude-sidebar ${aiStateClass}`}
    >
      <div className="refresh-message-container">
        <div className="refresh-message-content">
          <div className="refresh-message-text">
            <Typography
              label={message}
              variant="h6Medium"
              styles="refresh-message-typography"
            />
          </div>
          <Spinner theme={resolvedTheme} customClass="refresh-spinner" />
        </div>
      </div>
    </div>
  );
};
